/** Static values used for the metadata fields of the Collection Site. Adjusting these will reflect on both the frontend
 * as well as backend, since the backend uses it for some templating engine when a page is navigated to directly
 */
module.exports = {
  metaTitle: "Barnes Collection Online",
  metaPlaceName: "Barnes Foundation",
  metaDescription:
    "The Barnes Foundation in Philadelphia is home to one of the world's greatest collections of impressionist, post-impressionist and early modern paintings.",

  metaImage:
    "https://s3.amazonaws.com/barnes-image-repository/images/5003_92ad85ffeb13d697_n.jpg",
  defaultTitleURL: "barnes-collection-object",
};
